/*
 * Inits the builder showcase gallery page
 */
define('galleryInitializer',[
  'builderShowcaseObserver',
  'routes',
  'galleryPageTabsHandler',
  'favoritesLoader',
  'lazyLoad',
  'trackerBreadcrumbShowCase',
  'askQuestionLoader',
], (builderShowcaseObserver, routes) => {
  'use strict';

  const url = routes.BuilderShowcaseGalleryGetFirstPageUrl;
  const collectionsObject = document.querySelector('[data-gallery-collections]');
  const data = builderShowcaseObserver.getState().data;

  /**
   * Used to remove the disabled attributes once the data has been fetched.
   */
  function enableCategoryTabs() {
    const tabs = document.querySelectorAll('[data-gallery-button]');

    tabs.forEach((tab) => {
      const button = tab.closest('button');

      if (button) {
        button.removeAttribute('disabled');
      }
    });
  }

  /**
   * Used to click the selected categorie's button on initial load
   */
  function clickSelectedCategory() {
    if (!localStorage) {
      return;
    }

    const category = localStorage.getItem('selectedCategory');

    if (category && category !== 'undefined') {
      const button = document.querySelector(`button[data-collection="${category}"]`);
      button.click();

      // clear it so it only opens it once
      localStorage.removeItem('selectedCategory');
    }
  }

  /**
   * Used to initialize the gallery, and hydrate the collections with images.
   */
  async function init() {
    const brandId = data.BrandId;
    const request = await fetch(url + `?brandId=${brandId}`);
    const response = await request.text();

    // replace the old content with the full collections
    collectionsObject.innerHTML = response;
    enableCategoryTabs();
    clickSelectedCategory();
  }

  init();
});

